/* eslint-disable react/no-unknown-property */
import {
  CircularGaugeChart,
  FontWeight, HStack, Popover, PopoverProps, Stack, Text,
} from '@doveit/bricks';
import React from 'react';
import Markdown from 'react-markdown';
import { formatEuro } from '@doveit/hammer';
import { PerformanceRating } from '../../../providers/api/dtos';
import * as styles from './GoalPopover.style';
import { configByPerformanceRating } from '../../constants';

export interface GoalPopoverProps extends React.AriaAttributes {
  goal: {
    progress: number,
    status: PerformanceRating,
    target: number
  },
  trigger: PopoverProps['trigger'],
}

const GoalPopover: React.FC<GoalPopoverProps> = ({
  goal,
  trigger,
  ...rest
}) => (
  <Popover
    trigger={trigger}
    hasArrow
    placement="bottom-end"
    {...rest}
  >
    <div css={styles.wrapper}>
      <Stack gap={150}>
        <Text.BodySmall
          as="strong"
          fontWeight={FontWeight.MEDIUM}
        >
          Obiettivo di guadagno
        </Text.BodySmall>

        <HStack gap={150} wrap="nowrap">
          <div>
            <CircularGaugeChart
              progress={goal.progress}
              size="M"
              color={configByPerformanceRating[goal.status].color}
            />
          </div>
          <Text.BodySmall>
            <Markdown components={{ p: ({ _node, ...props }) => props.children }}>
              {`${configByPerformanceRating[goal.status].message.replace('.', '')} di **${formatEuro(goal.target)}**`}
            </Markdown>
          </Text.BodySmall>
        </HStack>
      </Stack>
    </div>
  </Popover>
);

export default GoalPopover;
